/* Complete the Fit — 2 Tone Logo Hat bundle builder
   - Adds the hat (from main product form) + the Camo Logo T = $125, then -> /checkout
   - Click listeners only (never a form submit) so udesly-shopify.min.js can't intercept
   - Self-contained: shares no listeners/vars with the main ATC button
*/
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    var section = document.getElementById("complete-the-fit");
    if (!section) return;

    var configEl = section.querySelector("[data-ctf-config]");
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error("CTF-HAT: bad config JSON", e);
      return;
    }

    var cards = Array.prototype.slice.call(section.querySelectorAll(".ctf-card"));
    var sizeWrap = section.querySelector(".ctf-size");
    var sizeOptions = section.querySelector(".ctf-size-options");
    var addBtn = section.querySelector(".ctf-add");
    var note = section.querySelector(".ctf-note");

    var selectedKey = null;
    var selectedVariantId = null;

    // ---- main product form (the hat). The bundle section has no form, so this
    // resolves to the real ATC form even with the selector scoped to document.
    function mainForm() {
      return document.querySelector('form[action="/cart/add"]');
    }
    function mainVariantId() {
      var f = mainForm();
      var input = f ? f.querySelector('input[name="id"]') : null;
      return input && input.value ? input.value : null;
    }
    // the hat is one-size, so the note just confirms what is in the bundle
    function mainSizeLabel() {
      var id = mainVariantId();
      if (!id || !window.product || !window.product.variants) return null;
      var v = window.product.variants.find(function (x) { return String(x.id) === String(id); });
      return v ? (v.option1 || v.title) : null;
    }
    function refreshNote() {
      note.textContent = "One size fits. Ships together in one parcel.";
    }

    function setAddState() {
      var ready = selectedKey && selectedVariantId;
      addBtn.disabled = !ready;
      if (!selectedKey) { addBtn.textContent = "Select an item"; return; }
      var opt = config.options[selectedKey];
      if (!opt.oneSize && !selectedVariantId) { addBtn.textContent = "Select a size"; return; }
      addBtn.textContent = "Add Bundle to Cart — " + config.bundlePrice;
    }

    function renderSizes(key) {
      var opt = config.options[key];
      sizeOptions.innerHTML = "";
      selectedVariantId = null;

      if (opt.oneSize) {
        // hat: no selector, auto-pick the single variant if available
        var only = opt.sizes[0];
        sizeWrap.hidden = true;
        selectedVariantId = only && only.available ? only.variantId : null;
        setAddState();
        return;
      }

      sizeWrap.hidden = false;
      opt.sizes.forEach(function (s) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "ctf-size-btn";
        b.textContent = s.size;
        if (!s.available) {
          b.disabled = true;
          b.title = "Sold out";
        } else {
          b.addEventListener("click", function () {
            sizeOptions.querySelectorAll(".ctf-size-btn").forEach(function (x) { x.classList.remove("is-selected"); });
            b.classList.add("is-selected");
            selectedVariantId = s.variantId;
            setAddState();
          });
        }
        sizeOptions.appendChild(b);
      });
      setAddState();
    }

    cards.forEach(function (card) {
      if (card.disabled) return;
      card.addEventListener("click", function () {
        var key = card.getAttribute("data-key");
        cards.forEach(function (c) { c.classList.remove("is-selected"); });
        card.classList.add("is-selected");
        selectedKey = key;
        renderSizes(key);
        refreshNote();
      });
    });

    // hat is one-size, but keep the listener so the note re-renders after any form change
    var pf = mainForm();
    if (pf) {
      pf.addEventListener("change", refreshNote);
      pf.addEventListener("click", function () { setTimeout(refreshNote, 0); });
    }

    addBtn.addEventListener("click", function () {
      if (addBtn.disabled) return;
      var mainId = mainVariantId();
      if (!mainId) { showError("Sorry, we could not read the hat from this page. Please reload and try again."); return; }
      if (!selectedVariantId) { showError("Please choose your tee size."); return; }

      addBtn.disabled = true;
      var prev = addBtn.textContent;
      addBtn.textContent = "Adding...";

      // Read as TEXT first. The cart endpoint does not always return JSON — a bot
      // check or proxy interstitial answers with an HTML page, and JSON.parse on that
      // throws "Unexpected token '<'", which must never reach a customer.
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [
          { id: mainId, quantity: 1 },
          { id: selectedVariantId, quantity: 1 }
        ] })
      })
        .then(function (r) {
          return r.text().then(function (body) {
            var data = null;
            try { data = JSON.parse(body); } catch (e) { data = null; }
            return { ok: r.ok, status: r.status, data: data, isJson: data !== null };
          });
        })
        .then(function (res) {
          if (!res.isJson) {
            // HTML came back instead of JSON — almost always a bot/verification page.
            throw new Error("__RETRY__");
          }
          if (!res.ok || res.status === 422) {
            throw new Error("__CART__:" + ((res.data && res.data.description) || ""));
          }
          // straight to checkout — avoids the cart drawer / Selleasy upsell JS errors
          window.location.href = "/checkout";
        })
        .catch(function (err) {
          console.error("CTF-HAT add error:", err);
          showError(friendlyError(err));
          addBtn.disabled = false;
          addBtn.textContent = prev;
        });
    });

    // Turn any failure into something a customer can act on. Never surface a parse
    // error, a status code, or Shopify's internal wording.
    function friendlyError(err) {
      var m = (err && err.message) || "";
      if (m === "__RETRY__") {
        return "We could not reach the cart just then. Please try again in a moment.";
      }
      if (m.indexOf("__CART__:") === 0) {
        var d = m.slice(9).toLowerCase();
        if (d.indexOf("sold out") > -1 || d.indexOf("not enough") > -1 || d.indexOf("stock") > -1) {
          return "That size just sold out. Please pick another.";
        }
        // "Cannot find variant" and anything else internal -> generic
        return "That combination is not available right now. Please try another size.";
      }
      return "Sorry, that did not work. Please try again.";
    }

    function showError(msg) {
      var existing = section.querySelector(".ctf-error");
      if (existing) existing.remove();
      var p = document.createElement("p");
      p.className = "ctf-error";
      p.setAttribute("role", "alert");
      p.style.cssText = "color:#d20404;font-size:13px;text-align:center;margin:10px 0 0;";
      p.textContent = msg;
      addBtn.insertAdjacentElement("afterend", p);
    }

    // init
    setAddState();
    refreshNote();
  });
})();
